import React, { useState } from 'react'
import moment from 'moment'
import { Button, Card, Chip, MenuItem, Grid, Select, CircularProgress, makeStyles, Table,
    TableBody, TableCell, TableHead, TablePagination, TableRow, Typography,
    InputLabel } from '@material-ui/core'
import DoneIcon from '@material-ui/icons/Done';
import InfoIcon from '@material-ui/icons/Info';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { TIPOS_ARCHIVOS_MIGRACION } from '../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from "react-router-dom";
import { descargarPadronSSS } from '../../actions/archivosMigracion';
import { ARCHIVOS_PERMISOS } from '../../utils/permisos';
import { validarSoloUnPermiso } from '../../helpers/permisos';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";


const useStyles = makeStyles((theme) => ({
    success: {
        backgroundColor: theme.palette.success.main,
        color: "#fff"
    },
    error: {
        backgroundColor: theme.palette.error.main,
        color: "#fff"
    },
    info: {
        backgroundColor: theme.palette.info.main,
        color: "#fff"
    },
}));

const TableSubidaArchivos = ({ data, setearValor, selectedDateDesde, selectedDateHasta,
    selectedTipoArchivo, handleSearch, paginaActual, registrosPorPagina, totalRegistros, ultimaPagina, loading, ...props }) => {
    const classes = useStyles()
    const dispatch = useDispatch()

    const { permisos: permisosUser } = useSelector(state => state.auth)
    
    const [page, setPage] = useState(0);
    const [redirect, setRedirect] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    if(data.length > 0){
        data.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
    }
    return (
        <Card>
            <Typography variant="subtitle1" style={{ padding: 16 }}>
                Listado de Archivos
                {
                    loading &&
                    <CircularProgress size={24} style={{ marginLeft: 15 }} />
                }
            </Typography>
            
            <Grid container className={classes.root} justify="left" spacing={1} style={{ padding: 10 }}>
                <Grid item xs={12} md={3}>
                    
                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils} >
                            <KeyboardDatePicker
                                margin="normal"
                                label="Fecha desde"
                                format="dd/MM/yyyy"
                                required={false}
                                clearLabel="Limpiar"
                                cancelLabel="Cancelar"
                                value={
                                moment(selectedDateDesde).isValid() ? moment(selectedDateDesde) : null
                                }
                                onChange={(date) => {
                                setearValor("selectedDateDesde", date);
                                }}
                                KeyboardButtonProps={{
                                "aria-label": "change date",
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    
                </Grid>                            
                <Grid item md={3} style={{ marginLeft: "2rem" }}>

                    <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils} >
                        <KeyboardDatePicker
                                margin="normal"
                                label="Fecha hasta"
                                format="dd/MM/yyyy"
                                required={false}
                                clearLabel="Limpiar"
                                cancelLabel="Cancelar"
                                value={
                                moment(selectedDateHasta).isValid() ? moment(selectedDateHasta) : null
                                }
                                onChange={(date) => {
                                setearValor("selectedDateHasta", date);
                                }}
                                KeyboardButtonProps={{
                                "aria-label": "change date",
                                }}
                        />
                    </MuiPickersUtilsProvider>

                </Grid>

                <Grid item md={3}  style={{ marginTop: "1.2rem", marginLeft: "2rem" }}>
                    <InputLabel id="select-tipo-label">Tipo de archivo</InputLabel>
                    <Select
                        value={selectedTipoArchivo}
                        onChange={(e) => {
                            setearValor("selectedTipoArchivo", e.target.value);
                        }}
                        disabled={false}
                        name="tipoArchivo"
                        validators={["required"]}
                        errorMessages={["El tipo es requerido"]}
                        fullWidth={true}
                        >
                        <MenuItem value="0">
                            <em>Seleccione</em>
                        </MenuItem>
                        <MenuItem value={"-1"}>TODOS</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.BAJAS}>Bajas</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.CAPITA_DESEMPLEO}>Capita Desempleo</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.CAPITA_JUBILADOS}>Capita Jubilados</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.DDJJ}>DDJJ</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.DEVOLUCIONES_SSS}>Devoluciones_SSS</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.ENVIO_PADRON_SSS}>Envío Padrón SSS</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.PADRON_SSS}>Padrón SSS</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.NOVEDADES_SSS}>Novedades SSS</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.PAGO_FACIL}>Pago facil</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.RELACIONES_LABORALES}>Relaciones Laborales</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.SANO}>SANO</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.SUBSIDIOS}>Subsidios</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.SUMA}>SUMA</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.SUMA_70}>SUMA 70</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.SUMARTE}>SUMARTE</MenuItem>
                        <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.TRANSFERENCIAS}>Transferencias</MenuItem>
                           <MenuItem value={TIPOS_ARCHIVOS_MIGRACION.BAJAS_POR_TRASPASO}>Bajas Por Traspaso</MenuItem>
                    </Select>
                </Grid>
                
                <Grid item md={2}  style={{ marginTop: "1.8rem", marginLeft: "1.5rem"}}> 
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleSearch()}
                    >
                      Buscar
                    </Button>
                </Grid>

            </Grid>

            <Table>

                <TableHead>
                    <TableRow>
                        <TableCell>Nombre de archivo</TableCell>
                        <TableCell>Fecha de subida</TableCell>
                        <TableCell>Usuario</TableCell>
                        <TableCell>Periodo</TableCell>
                        <TableCell>Tipo de Archivo</TableCell>
                        <TableCell>Estado</TableCell>
                        <TableCell>Acciones</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((fila) => {
                        return (
                            <TableRow hover key={fila.Id}>
                                <TableCell>{fila.nombre}</TableCell>
                                <TableCell>{moment(fila.fecha).format("DD/MM/YYYY")}</TableCell>
                                <TableCell>{fila.usuario.userName}</TableCell>

                                <TableCell>{fila.periodo}</TableCell>
                                <TableCell>{fila?.tipoArchivo?.descripcion}</TableCell>
                                <TableCell>
                                    {
                                        fila.idEstadoArchivo === 1 &&
                                        <Chip icon={<InfoIcon style={{ color: "#fff" }} />} label={fila.estadoArchivo.descripcion} clickable className={classes.info} />
                                    }
                                    {
                                        fila.idEstadoArchivo === 2 &&
                                        <Chip icon={<DoneIcon style={{ color: "#fff" }} />} label={fila.estadoArchivo.descripcion} clickable className={classes.success} />
                                    }
                                    {
                                        fila.idEstadoArchivo === 3 &&
                                        <Chip icon={<HighlightOffIcon style={{ color: "#fff" }} />} label={fila.estadoArchivo.descripcion} clickable className={classes.error} />
                                    }
                                </TableCell>
                                <TableCell>
                                    {
                                        fila.idTipoArchivo === TIPOS_ARCHIVOS_MIGRACION.PADRON_SSS &&
                                        <Button variant="contained" color="primary" size="small" onClick={()=>dispatch(descargarPadronSSS())}>Descargar TXT</Button>
                                    }
                                    {
                                        fila.idTipoArchivo === TIPOS_ARCHIVOS_MIGRACION.NOVEDADES_SSS && 
                                        fila.idEstadoArchivo === 2 && validarSoloUnPermiso(permisosUser, ARCHIVOS_PERMISOS.MARCAR_BAJAS) &&
                                        <Button variant="contained" color="primary" size="small" onClick={() => setRedirect(true)}>MARCAR BAJAS</Button>
                                    }
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
                {redirect && (
                    <Redirect
                    to={{
                        pathname: "/contrataciones/archivos/novedadesSss",
                    }}
                    />
                )}
            </Table>
            {
                data.length === 0 &&
                <div style={{ textAlign: "center", marginTop: "1rem" }} >
                    No hay resultados para su búsqueda
                </div>
            }
            <TablePagination
                component="div"
                className="paginador"
                count={data.length}
                rowsPerPageOptions={[5, 10, 20]}
                labelRowsPerPage="Filas por página"
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Card>
    )
}

export default TableSubidaArchivos
